import { AttachmentRule, Behavior } from "./types";

export class TemporaryBehavior extends Behavior {
  private startTime: number = 0;
  private lifespan: number = 5000; // Default 5 seconds

  static getAttachmentRules(): AttachmentRule[] {
    return [{ type: "class", selector: "temporary" }];
  }

  onAttach(): void {
    console.log("TemporaryBehavior attached to:", this.element);

    // Record when this behavior was attached
    this.startTime = Date.now();

    // Check for custom lifespan in data attribute (in milliseconds)
    const lifespanAttr = this.element.getAttribute("data-lifespan");
    if (lifespanAttr) {
      const customLifespan = parseInt(lifespanAttr, 10);
      if (!isNaN(customLifespan) && customLifespan > 0) {
        this.lifespan = customLifespan;
      }
    }

    console.log(`Element will be destroyed in ${this.lifespan}ms`);
  }

  onDetach(): void {
    console.log("TemporaryBehavior detached from:", this.element);
  }

  private destroyElement(): void {
    // Check if element is still in the DOM to avoid double-destruction
    if (!this.element.parentNode) {
      console.log("Element already removed from DOM, skipping destruction");
      return;
    }

    console.log("Destroying temporary element after lifespan expired:", this.element);

    // Dispatch a custom event before destruction
    const destroyEvent = new CustomEvent("element-destroyed", {
      detail: {
        element: this.element,
        reason: "temporary-lifespan-expired",
      },
      bubbles: true,
    });
    this.element.dispatchEvent(destroyEvent);

    // Remove the element from the DOM
    // The MutationObserver should detect this and clean up behaviors automatically
    this.element.remove();
  }

  tick(deltaTime: number): void {
    // Check if element is still in the DOM first
    if (!this.element.parentNode) {
      return;
    }

    // Check if lifespan has expired
    const currentTime = Date.now();
    const elapsedTime = currentTime - this.startTime;

    if (elapsedTime >= this.lifespan) {
      this.destroyElement();
    }
  }
}
